import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MeterHistorySharedService {
  private subjectOpenMeterEntryAddModal = new BehaviorSubject(null);
  private subjectOpenVehicleModelTableChanged = new BehaviorSubject(null);
  private subjectOpenMeterEntryEditModal = new BehaviorSubject(null);
  private subjectOpenMeterEntryVoidModal = new BehaviorSubject(null);
  private subjectOpenRecordHistoryEditModal = new BehaviorSubject(null);

  constructor() { }

  setsubjectOpenMeterEntryAddModal(string: string) {
    this.subjectOpenMeterEntryAddModal.next(string);
  }

  getsubjectOpenMeterEntryAddModal(): Observable<any> {
    return this.subjectOpenMeterEntryAddModal.asObservable();
  }
  setsubjectOpenMeterHistoryTableChanged(flag: boolean) {
    this.subjectOpenVehicleModelTableChanged.next(true);
  }

  getsubjectOpenMeterHistoryTableChanged(): Observable<boolean> {
    return this.subjectOpenVehicleModelTableChanged.asObservable();
  }

  setsubjectOpenMeterEntryEditModal(id: string) {
    this.subjectOpenMeterEntryEditModal.next(id);
  }

  getsubjectOpenMeterEntryEditModal(): Observable<any> {
    return this.subjectOpenMeterEntryEditModal.asObservable();
  }

  setsubjectOpenMeterEntryVoidModal(id: string) {
    this.subjectOpenMeterEntryVoidModal.next(id);
  }

  getsubjectOpenMeterEntryVoidModal(): Observable<any> {
    return this.subjectOpenMeterEntryVoidModal.asObservable();
  }

  setsubjectOpenRecordHistoryModal(id: string) {
    this.subjectOpenRecordHistoryEditModal.next(id);
  }

  getsubjectOpenRecordHistoryModal(): Observable<any> {
    return this.subjectOpenRecordHistoryEditModal.asObservable();
  }
}
